import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { isBooleanQuery, searchWords } from '@/components/AdvancedSearch/lib/isValidQuerySyntax'
import { factboxFields } from '@/components/AdvancedSearch/configs'

/**
 * Article-embedded factboxes are matched on any word of the text, so a boolean search
 * only applies to originals. Says so while one is active and article factboxes are
 * part of the search.
 */
export const ArticleSearchNotice = ({ text, origin }: {
  text: string
  origin?: string
}): JSX.Element | null => {
  const { t, i18n } = useTranslation('views')

  const words = origin === 'core/factbox' || !isBooleanQuery(text, factboxFields)
    ? []
    : searchWords(text, factboxFields)
  if (!words.length) {
    return null
  }

  const anyOf = new Intl.ListFormat(i18n.language, { type: 'disjunction' }).format(words)

  return (
    <span
      className='min-w-0 truncate text-xs text-muted-foreground'
      title={t('factboxes.articleSearchNotice.explanation', { words: anyOf })}
    >
      {t('factboxes.articleSearchNotice.short', { words: anyOf })}
    </span>
  )
}
